import useIntl from "@/utils/intl";
import axios from "axios";
import React, { useState } from "react";

interface ModalProps {
  isVisible: boolean;
  onClose: () => void;
}

const Modal: React.FC<ModalProps> = ({ isVisible, onClose }) => {
  const { translate } = useIntl();
  const [formData, setFormData] = useState({
    phone: "",
    city: "",
    district: "",
    khoroo: "",
    apartment: "",
    doornumber: "",
    suhname: "",
    suhcontact1: "",
    suhcontact2: "",
    subject: "Сүлжээ оруулах хүсэлт",
  });

  const [isSuccess, setIsSuccess] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const {
      phone,
      city,
      district,
      khoroo,
      apartment,
      doornumber,
      suhname,
      suhcontact1,
      suhcontact2,
      subject,
    } = formData;

    if (phone.length === 0) {
      alert("Утасны дугаар оруулна уу.");
      return;
    }

    // Send the request without waiting for the response
    axios
      .post("/api/sendEmail", {
        data:
          "Phone: " +
          phone +
          "Apartment Info: " +
          city +
          district +
          khoroo +
          apartment +
          doornumber +
          "SUH information: " +
          suhname +
          "SUH contact: " +
          suhcontact1 +
          "," +
          suhcontact2,
        subject,
      })
      .catch((error) => {
        // Optionally handle error
        console.error("An error occurred:", error);
      });

    setIsSuccess(true);
    setTimeout(() => {
      setIsSuccess(false);
      onClose();
    }, 2000); // Close modal after 2 seconds
  };

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-surfaceInverse rounded-lg p-5 w-auto">
        <div className="relative flex flex-row gap-2 items-center justify-between mb-5">
          <h2 className="text-base font-bold text-textHigh">
            {translate("request.network")}
          </h2>
          <button
            type="button"
            className="rounded-md p-2 inline-flex items-center justify-center text-textHigh bg-black/5 focus:outline-none focus:ring-2 focus:ring-inset"
            onClick={onClose}
          >
            <span className="sr-only">Close menu</span>
            <svg
              className="h-6 w-6"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              aria-hidden="true"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="flex flex-row gap-10">
            <div>
              <div className="mb-4">
                <label
                  className="block text-textHigh text-sm font-bold mb-2"
                  htmlFor="name"
                >
                  {translate("phoneNumber")}:
                  <span className="text-red-500 ml-1">*</span>
                </label>
                <input
                  id="phone"
                  type="text"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  className="shadow appearance-none required border rounded w-full py-2 px-3 text-textHigh leading-tight focus:outline-none focus:shadow-outline"
                  required
                  pattern="\d{8}"
                  title="Зөв дугаар оруулна уу."
                />
              </div>
              <div className="mb-4">
                <label
                  className="block text-textHigh text-sm font-bold mb-2"
                  htmlFor="name"
                >
                  {translate("COX.name")}:
                </label>
                <input
                  id="suhname"
                  type="text"
                  name="suhname"
                  value={formData.suhname}
                  onChange={handleChange}
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-textHigh leading-tight focus:outline-none focus:shadow-outline"
                />
              </div>
              <div className="mb-4">
                <label
                  className="block text-textHigh text-sm font-bold mb-2"
                  htmlFor="name"
                >
                  {translate("COX.contact1")}:
                </label>
                <input
                  id="suhcontact1"
                  type="text"
                  name="suhcontact1"
                  value={formData.suhcontact1}
                  onChange={handleChange}
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-textHigh leading-tight focus:outline-none focus:shadow-outline"
                />
              </div>
              <div className="mb-4">
                <label  
                  className="block text-textHigh text-sm font-bold mb-2"
                  htmlFor="name"
                >
                  {translate("COX.contact2")}:
                </label>
                <input
                  id="suhcontact2"
                  type="text"
                  name="suhcontact2"
                  value={formData.suhcontact2}
                  onChange={handleChange}
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-textHigh leading-tight focus:outline-none focus:shadow-outline"
                  pattern="\d{8}"
                  title="Зөв дугаар оруулна уу."
                />
              </div>
            </div>

            <div>
              <div className="mb-4">
                <label
                  className="block text-textHigh text-sm font-bold mb-2"
                  htmlFor="city"
                >
                  {translate("city")}:
                  <span className="text-red-500 ml-1">*</span>
                </label>
                <input
                  id="city"
                  type="text"
                  name="city"
                  value={formData.city}
                  onChange={handleChange}
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-textHigh leading-tight focus:outline-none focus:shadow-outline"
                  required
                />
              </div>
              <div className="mb-4">
                <label
                  className="block text-textHigh text-sm font-bold mb-2"
                  htmlFor="district"
                >
                  {translate("district")}:
                  <span className="text-red-500 ml-1">*</span>
                </label>
                <input
                  id="district"
                  type="text"
                  name="district"
                  value={formData.district}
                  onChange={handleChange}
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-textHigh leading-tight focus:outline-none focus:shadow-outline"
                  required
                />
              </div>
              <div className="mb-4">
                <label
                  className="block text-textHigh text-sm font-bold mb-2"
                  htmlFor="khoroo"
                >
                  {translate("quarter")}:
                  <span className="text-red-500 ml-1">*</span>
                </label>
                <input
                  id="khoroo"
                  type="text"
                  name="khoroo"
                  value={formData.khoroo}
                  onChange={handleChange}
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-textHigh leading-tight focus:outline-none focus:shadow-outline"
                  required
                />
              </div>
              <div className="mb-4">
                <label
                  className="block text-textHigh text-sm font-bold mb-2"
                  htmlFor="apartment"
                >
                  {translate("apartment")}:
                  <span className="text-red-500 ml-1">*</span>
                </label>
                <input
                  id="apartment"
                  type="text"
                  name="apartment"
                  value={formData.apartment}
                  onChange={handleChange}
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-textHigh leading-tight focus:outline-none focus:shadow-outline"
                  required
                />
              </div>
            </div>
          </div>
          <div className="mb-4">
            <label
              className="block text-textHigh text-sm font-bold mb-2"
              htmlFor="doornumber"
            >
              {translate("apartment.door")}:
              <span className="text-red-500 ml-1">*</span>
            </label>
            <input
              id="doornumber"
              type="text"
              name="doornumber"
              value={formData.doornumber}
              onChange={handleChange}
              className="shadow appearance-none border rounded w-full py-2 px-3 text-textHigh leading-tight focus:outline-none focus:shadow-outline"
              required
            />
          </div>
          <div className="flex items-center w-full justify-center pt-2">
            <button
              type="submit"
              className="bg-red-600 w-full text-white py-1 px-4 rounded-lg hover:bg-red-700 transition-colors duration-100"
            >
              {translate("request.toSend")}
            </button>
          </div>
        </form>
        {isSuccess && (
          <div className="fixed inset-0 bg-black bg-opacity-20 flex justify-center items-center z-60">
            <div className="bg-white rounded-lg p-5">
              <h3 className="text-lg">{translate("request.sent")}</h3>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Modal;
